// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"3715":"94164e34bdc73684b1db","7228":"7dd9d8b8ccb1ef7ff195","7503":"404e6c258d12882eadaa"}[chunkId] + ".css";
};